/**
 * 2 minutes — ~1/5 of the Clockwork batch recompute cadence (10 min, see
 * daemons/scheduler.rb). A poll at this interval catches any background
 * status recompute (Instruments::RecomputeTaskCurrentStatusService) within
 * 2 minutes of it happening, well within the "near real-time" expectation
 * for task status badges and compliance figures (E35-S35).
 */
export const STATUS_POLL_INTERVAL_MS = 2 * 60 * 1000
